import { createContext, type FC } from "react";

import {
  DIALOG_HEADER_DEFAULTS,
  type TDialogHeaderSize,
  TDialogHeaderProps,
} from "@/ui/components/overlay/Dialog/Dialog.config";
import { cn } from "@/ui/lib/utils";

export const DialogHeaderSizeContext = createContext<TDialogHeaderSize>(
  DIALOG_HEADER_DEFAULTS.size,
);

export const DialogHeader: FC<TDialogHeaderProps> = (
  {
    className,
    children,
    size = DIALOG_HEADER_DEFAULTS.size,
    ...props
  },
) => (
  <DialogHeaderSizeContext.Provider value={size}>
    <div
      data-component="DialogHeader"
      className={cn(
        "flex flex-col gap-1",
        className,
      )}
      {...props}
    >
      { children }
    </div>
  </DialogHeaderSizeContext.Provider>
);

DialogHeader.displayName = "DialogHeader";
